import { FC, ReactNode } from 'react';

import { Flex, Text } from '@hh.ru/magritte-ui';

import styles from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignCard/CampaignCard.module.less';

interface CampaignParameterRowProps {
    label: string;
    children: ReactNode;
}

export const CampaignParameterRow: FC<CampaignParameterRowProps> = ({ label, children }) => {
    return (
        <Flex align="center" justify="space-between" gap={12} minWidth={0}>
            <Text typography="label-3-regular" style="secondary">
                {label}
            </Text>
            <Flex justify="flex-start" className={styles.parameterValue}>
                {children}
            </Flex>
        </Flex>
    );
};
